import { Routes } from '@angular/router';
import { AuthGuardService } from '@mp-core/guards/auth-guard.service';
import { AnonymousGuardService } from '@mp-core/guards/anonymous-guard.service';
import { PrivacyComponent } from '@mp-shared/components/privacy/privacy.component';
import { TermsComponent } from '@mp-shared/components/terms/terms.component';

export const APP_ROUTES: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadChildren: () => import('./modules/landing/landing.module').then(m => m.LandingModule),
    // canActivate: [AnonymousGuardService],
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./modules/dashboard/dashboard.module').then(m => m.DashboardModule),
    // canActivate: [AuthGuardService],
  },
  {
    path: 'privacy',
    component: PrivacyComponent
  },
  {
    path: 'terms',
    component: TermsComponent
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];
